module.exports = __webpack_public_path__ + "static/media/landing.da4215af.jpg";